import React from 'react';
import {t} from "utils/i18n";

const Preview = ({file}) => {
    return (
        <>
            {file && file.type.indexOf('image') > -1 && <img id='_image' alt='' className='preview_img'/>}
            {file && file.type.indexOf('video') > -1 &&
            <video id="_videoPlayer" style={{margin:'auto'}} width='100%' height='100%' controls="controls"></video>}
            {file && file.type.indexOf('audio') > -1 &&
            <audio id="_audioPlayer" style={{margin:'auto'}} width='100%' height='100%' controls="controls"></audio>}
            {file && file.type.indexOf('pdf') > -1 && <embed id='_pdf' width='100%' height='100%'/>}
            {file && file.type.indexOf('json') > -1 && <embed id='_json' width='100%' height='100%' style={{background:'#C7DAFF'}}/>}
            {file && (file.type.indexOf('json') === -1
                && file.type.indexOf('pdf') === -1
                && file.type.indexOf('audio') === -1
                && file.type.indexOf('video') === -1
                && file.type.indexOf('image') === -1) && <div className='text-white flex items-center'>{t('no_preview')}</div>
            }
        </>

    )

}

export default Preview;